export default "__VITE_ASSET__dEPWKqxQ__"